module.exports = __webpack_public_path__ + "media/images/official/removeanxieties_graph1-23e2d2181a33cc10111c53e97c1ec644.png";